/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.
const config = {};
config.sitecoreApiKey = process.env.VUE_APP_SITECORE_API_KEY || "no-api-key-set";
config.sitecoreApiHost = process.env.VUE_APP_SITECORE_API_HOST || "";
config.sitecoreSiteName = process.env.VUE_APP_SITECORE_SITE_NAME || "probio-portal";
config.imageHost = process.env.VUE_APP_IMAGE_HOST || "http://cm.it.genscript.com:3000";
config.imageHostPrefix = process.env.VUE_APP_IMAGE_HOST_PREFIX || "https://probio.nttdatadm.com";
config.layoutServiceConfigurationName = process.env.VUE_APP_LAYOUT_SERVICE_CONFIGURATION_NAME || "default";
config.defaultLanguage = process.env.VUE_APP_DEFAULT_LANGUAGE || "en-US";
config.graphQLEndpointPath = process.env.VUE_APP_GRAPH_QL_ENDPOINT_PATH || "/sitecore/api/graph/edge";
config.graphQLEndpoint = process.env.VUE_APP_GRAPH_QL_ENDPOINT || `${config.sitecoreApiHost}${config.graphQLEndpointPath}`;
module.exports = config;